<template>
    <div v-if="show && !closeTrialBanner && !closeUpgradeBanner" :class="[$prefixClass.card + '-stroke try-perceived-speed']">
        <template v-if="!store.trial_end">
            <i class="try-perceived-speed__close-box far fa-times" @click="closeTrial"></i>
            <vue-loading :loading="isLoading"></vue-loading>
            <img src="@/assets/images/tooltip-perceived.svg" alt="perceived" class="try-perceived-speed__img">
            <h4 class="try-perceived-speed__title">{{$t('dashboard.box_try_perceived_speed.title')}}</h4>
            <p v-html="$t('dashboard.box_try_perceived_speed.content')"></p>
            <a-button type="default" @click="$router.push({name: $routerName.PRICING})">{{$t('dashboard.box_try_perceived_speed.btn_text')}}</a-button>
            <!-- <vue-modal-quick-tutorial v-model="modalQuickTutorial" @startTrial="letStartTrial"></vue-modal-quick-tutorial> -->
        </template>
        <template v-else>
            <i class="try-perceived-speed__close-box far fa-times" @click="closeUpgrade"></i>
            <img src="@/assets/images/tooltip-perceived.svg" alt="perceived" class="try-perceived-speed__img">
            <h4 class="try-perceived-speed__title">{{$t('dashboard.box_try_perceived_speed.title_upgrade')}}</h4>
            <p v-html="$t('dashboard.box_try_perceived_speed.content_upgrade')"></p>
            <a-button type="default" @click="$router.push({name: $routerName.PRICING})">{{$t('dashboard.box_try_perceived_speed.btn_select')}}</a-button>
        </template>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { types as typesDashboard } from './../constant'
import { types as typesAuth } from "@/modules/auth/constant"
import cookie from 'js-cookie'
export default {
    name: 'BoxTryPerceivedSpeed',
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            show: false,
            isLoading: false,
            closeTrialBanner: false,
            closeUpgradeBanner: false,
            // modalQuickTutorial: {
            //     isVisible: false,
            //     type: 'preloading'
            // },
            modalSucessMedium: {
                isVisible: false,
                title: this.$t('dashboard.component.features_unlocked'),
                description: this.$t('dashboard.component.premium_zone')
            }
        }
    },
    computed: {
        ...mapGetters({
            store: typesAuth.getters.GET_STORE
        }),
        isVisible: {
            get: function() {
                return this.value
            },
            set: function(newValue) {
                this.$emit('input', newValue)
            }
        }
    },
    watch: {
        isVisible: {
            handler( val ) {
                if ( val ) {
                    this.closeTrialBanner = cookie.get('close-trial-banner') ? true : false
                    this.closeUpgradeBanner = cookie.get('close-upgrade-banner') ? true : false
                    this.show = !this.store.trial_end || (this.store.trial_end && new Date() <=  new Date(this.store.trial_end ))
                } else {
                    this.show = false
                }
            },
            deep: true
        }
    },
    created() {
        if ( this.isVisible ) {
            this.closeTrialBanner = cookie.get('close-trial-banner') ? true : false
            this.closeUpgradeBanner = cookie.get('close-upgrade-banner') ? true : false
            this.show = !this.store.trial_end || (this.store.trial_end && new Date() <=  new Date(this.store.trial_end ))
        }
    },
    methods: {
        ...mapActions({
            getStore: typesAuth.actions.GET_STORE,
            startTrial: typesDashboard.actions.START_TRIAL
        }),
        closeTrial() {
            if ( cookie.get('close-trial-banner-first-time') ) {
                cookie.remove('close-trial-banner')
                cookie.remove('close-trial-banner-first-time')
                cookie.set('close-trial-banner', true, { expires: 30*6 })
            } else {
                cookie.set('close-trial-banner-first-time', true, { expires: 30 })
                cookie.set('close-trial-banner', true, { expires: 7 })
            }
            this.isVisible = false
        },
        closeUpgrade() {
            if ( cookie.get('close-upgrade-banner-first-time') ) {
                cookie.remove('close-upgrade-banner')
                cookie.remove('close-upgrade-banner-first-time')
                cookie.set('close-upgrade-banner', true, { expires: 30*6 })
            } else {
                cookie.set('close-upgrade-banner-first-time', true, { expires: 30 })
                cookie.set('close-upgrade-banner', true, { expires: 7 })
            }
            this.isVisible = false
        },
        // async letStartTrial() {
        //     let self = this
        //     this.isLoading = true
        //     await this.startTrial().then(res => {
        //         let { status=false } = res.data
        //         if ( status ) {
        //             self.$emit('trial-success')
        //             self.modalQuickTutorial.isVisible = false
        //             self.getStore()
        //         } else {
        //             self.toastError({
        //                 title: "Error",
        //                 message: "Something went wrong",
        //                 duration: 4
        //             })
        //         }
        //         self.isLoading = false
        //     }).catch(e => {
        //         self.isLoading = false
        //         console.log(e);
        //     })
        // }
    }
}
</script>
<style lang="scss">
    .try-perceived-speed {
        min-width: 358px;
        width: 358px;
        padding: 28px 32px 24px 32px;
        background-image: url(../assets/bg-box.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 8px;
        color: #FFFFFF;
        text-align: center;
        position: relative;
        &__block {
            height: 96px;
            border-radius: 8px;
            background-color: #ffffff;
        }
        &__title {
            padding-top: 10px;
        }
        &__close-box {
            position: absolute;
            top: 10px;
            right: 15px;
            cursor: pointer;
        }
        &__img {
            width: 113px;
        }
    }
</style>